import React from 'react';
import { motion } from 'framer-motion';
import type { Cue } from '../../types/snak';
import { snakMeta } from '../../data/snak';
interface ChoiceCueProps {
  cue: Cue;
  selected: string | null;
  onSelect: (id: string) => void;
  /** Show the live congress peer share once the HCP has answered. */
  showPeerData?: boolean;
}
const EASE = [0.23, 1, 0.32, 1] as const;
const INDEX = ['A', 'B', 'C', 'D'];
export function ChoiceCue({
  cue,
  selected,
  onSelect,
  showPeerData = false
}: ChoiceCueProps) {
  const answered = selected !== null;
  const mine = cue.options.find(o => o.id === selected);
  return <div data-id="element-19" data-mp="22uonc3b0czcf">
      <div className="grid gap-3 sm:grid-cols-3" role="group" aria-label={cue.question} data-id="element-20" data-mp="22uevsbabek4m">
        {cue.options.map((opt, i) => {
        const isMine = selected === opt.id;
        return <motion.button key={opt.id} type="button" initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.24,
          delay: 0.06 + i * 0.05,
          ease: EASE
        }} onClick={() => onSelect(opt.id)} aria-pressed={isMine} className={`flex items-start gap-3.5 rounded-2xl border px-5 py-5 text-left transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue ${answered ? isMine ? 'border-navy bg-navy' : 'border-line bg-paper opacity-40' : 'border-line bg-paper hover:border-blue hover:bg-sky/40'}`} data-id="element-21" data-mp="2vcswcin1ck7e" data-mpi={i}>
              <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border font-display text-[11px] font-bold ${isMine ? 'border-mint/40 bg-mint/20 text-mint' : 'border-line text-mut'}`} aria-hidden="true" data-id="element-22" data-mp="1eliqyv3e4df1">
                {INDEX[i]}
              </span>
              <span className={`flex-1 text-[15.5px] font-medium leading-snug ${isMine ? 'text-paper' : 'text-navy'}`} data-id="element-23" data-mp="3dvqs8ys4ntsb">
                {opt.label}
              </span>
            </motion.button>;
      })}
      </div>

      {answered && showPeerData && mine?.share !== undefined && <motion.div initial={{
      opacity: 0,
      y: 6
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.24,
      ease: EASE
    }} className="mt-4 flex items-center gap-4" data-id="element-24" data-mp="2yihm3zcsq51e">
          <span className="font-display text-[26px] font-bold leading-none tabular-nums text-blue" data-id="element-25" data-mp="3q9487a5zlyhx">
            {mine.share}%
          </span>
          <div className="flex-1" data-id="element-26" data-mp="3hgk7m464xjug">
            <div className="h-1 w-full overflow-hidden rounded-full bg-line" data-id="element-27" data-mp="3hf91hxp7w006">
              <motion.div initial={{
            scaleX: 0
          }} animate={{
            scaleX: mine.share / 100
          }} transition={{
            duration: 0.28,
            delay: 0.06,
            ease: EASE
          }} style={{
            transformOrigin: 'left'
          }} className="h-full bg-blue" data-id="element-28" data-mp="hssspqxlzup9" />
            </div>
            <p className="mt-1.5 text-[11.5px] text-mut" data-id="element-29" data-mp="20o6yh2tutpk7">{snakMeta.peerLabel}</p>
          </div>
        </motion.div>}
    </div>;
}